import React from 'react';
import { PaywallOption } from '@appTypes/paywallOptionType';
import { PaywallLink } from '@appTypes/paywallLinkType';
import { PaywallBox } from '@components/paywall/PaywallBox';
import * as S from './PayWall.styles';

export interface Props {
  value: {
    paywallOptions: PaywallOption;
    paywallLink?: PaywallLink;
    paywallLinkSecondary?: PaywallLink;
  };
}

export const PayWallBlock = ({ value: { paywallLink, paywallLinkSecondary, paywallOptions } }: Props) => (
  <S.Wrapper>
    <PaywallBox paywallOptions={paywallOptions} paywallLink={paywallLink} paywallLinkSecondary={paywallLinkSecondary} />
    <S.TransparentGradient />
  </S.Wrapper>
);
